export default "__VITE_ASSET__CdIjztuE__"